import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import AccountmasterViewPage from 'pages/accountmaster/View';
import BranchmasterViewPage from 'pages/branchmaster/View';
import LoangroupViewPage from 'pages/loangroup/View';
import LoanproductViewPage from 'pages/loanproduct/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const GrouploancontractBranchListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		},
		disbursementdate: {
			tagTitle: $t('disbursementDate'),
			value: [],
			valueType: 'range-date',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	// return sum of loanamount for the current records
	const totalLoanamount = utils.sum(records, 'loanamount');
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/grouploancontract/view/${data.loanaccountno}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('grouploancontract/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/grouploancontract/edit/${data.loanaccountno}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('grouploancontract/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.loanaccountno) },
			icon: "pi pi-trash",
			visible: () => auth.canView('grouploancontract/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function LoanaccountnoTemplate(data){
		if(data){
			return (
				<Link to={`/grouploancontract/view/${data.loanaccountno}`}> { data.loanaccountno }</Link>
			);
		}
	}
	function GroupidTemplate(data){
		if(data){
			return (
				<>{data.groupid && <Button className="p-button-text" icon="pi pi-eye" label={$t('loangroup')} onClick={() => app.openPageDialog(<LoangroupViewPage isSubPage apiPath={`/loangroup/view/${data.groupid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function BranchcodeTemplate(data){
		if(data){
			return (
				<>{data.branchcode && <Button className="p-button-text" icon="pi pi-eye" label={$t('branchmaster')} onClick={() => app.openPageDialog(<BranchmasterViewPage isSubPage apiPath={`/branchmaster/view/${data.branchcode}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function LoanproductidTemplate(data){
		if(data){
			return (
				<>{data.loanproductid && <Button className="p-button-text" icon="pi pi-eye" label={$t('loanproduct')} onClick={() => app.openPageDialog(<LoanproductViewPage isSubPage apiPath={`/loanproduct/view/${data.loanproductid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function DatecontractstartsTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.datecontractstarts )}</>
			);
		}
	}
	function DatecontractendsTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.datecontractends )}</>
			);
		}
	}
	function DisbursementdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.disbursementdate )}</>
			);
		}
	}
	function AcCodeTemplate(data){
		if(data){
			return (
				<>{data.ac_code && <Button className="p-button-text" icon="pi pi-eye" label={$t('accountmaster')} onClick={() => app.openPageDialog(<AccountmasterViewPage isSubPage apiPath={`/accountmaster/view/${data.ac_code}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function MemberidTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_memberid }</>
			);
		}
	}
	function MembernameTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_membername }</>
			);
		}
	}
	function GroupidTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_groupid }</>
			);
		}
	}
	function FatherNameTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_father_name }</>
			);
		}
	}
	function HusbandNameTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_husband_name }</>
			);
		}
	}
	function JoiningdateTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_joiningdate }</>
			);
		}
	}
	function DobTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_dob }</>
			);
		}
	}
	function AgeTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_age }</>
			);
		}
	}
	function Addressline1Template(data){
		if(data){
			return (
				<>{ data.membermaster_addressline1 }</>
			);
		}
	}
	function Addressline2Template(data){
		if(data){
			return (
				<>{ data.membermaster_addressline2 }</>
			);
		}
	}
	function PolicestationTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_policestation }</>
			);
		}
	}
	function DistrictTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_district }</>
			);
		}
	}
	function PincodeTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_pincode }</>
			);
		}
	}
	function StatenameTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_statename }</>
			);
		}
	}
	function BranchcodeTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_branchcode }</>
			);
		}
	}
	function Id1Template(data){
		if(data){
			return (
				<>{ data.membermaster_id1 }</>
			);
		}
	}
	function Id2Template(data){
		if(data){
			return (
				<>{ data.membermaster_id2 }</>
			);
		}
	}
	function IdcardnumberTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_idcardnumber }</>
			);
		}
	}
	function IdcardnumberExTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_idcardnumber_ex }</>
			);
		}
	}
	function IdcardpictureTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.membermaster_idcardpicture} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function ReligionTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_religion }</>
			);
		}
	}
	function CasteTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_caste }</>
			);
		}
	}
	function OccupationTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_occupation }</>
			);
		}
	}
	function QualificationTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_qualification }</>
			);
		}
	}
	function MobilenoTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_mobileno }</>
			);
		}
	}
	function MobilenoExTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_mobileno_ex }</>
			);
		}
	}
	function NomineenameTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_nomineename }</>
			);
		}
	}
	function MotherNameTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_mother_name }</>
			);
		}
	}
	function MaritalStatusTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_marital_status }</>
			);
		}
	}
	function AreaTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_area }</>
			);
		}
	}
	function SubareaTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_subarea }</>
			);
		}
	}
	function BanknameTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_bankname }</>
			);
		}
	}
	function AccountnoTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_accountno }</>
			);
		}
	}
	function IfsecTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_ifsec }</>
			);
		}
	}
	function ReskEvaluatedTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_resk_evaluated }</>
			);
		}
	}
	function PhotoUploadTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.membermaster_photo_upload} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function IdUploadTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_id_upload }</>
			);
		}
	}
	function SignUploadTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_sign_upload }</>
			);
		}
	}
	function HouseUploadTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_house_upload }</>
			);
		}
	}
	function MapUploadTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_map_upload }</>
			);
		}
	}
	function NomineeRelationTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_nominee_relation }</>
			);
		}
	}
	function NomineeAgeTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_nominee_age }</>
			);
		}
	}
	function PancardTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_pancard }</>
			);
		}
	}
	function GenderTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_gender }</>
			);
		}
	}
	function PanVerifyTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_pan_verify }</>
			);
		}
	}
	function AadharVerifyTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_aadhar_verify }</>
			);
		}
	}
	function EmailTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_email }</>
			);
		}
	}
	function AccountVerifyTemplate(data){
		if(data){
			return (
				<>{ data.membermaster_account_verify }</>
			);
		}
	}
	function UseridTemplate(data){
		if(data){
			return (
				<>{ data.users_userid }</>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-grouploancontract`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="grouploancontract/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="GrouploancontractBranchListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="sm:col-12 comp-grid" >
                </div>
                <div className="col " >
                    <Title title={$t('loanContract')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 comp-grid" >
                    <Link to={`/grouploancontract/index`}>
                        <Button label={$t('approve')} icon="pi pi-check-square" type="button" className="p-button w-full bg-primary-color "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.disbursementdate.value} onChange={(e) => setFilterValue('disbursementdate', e.value)} placeholder={$t('selectDate')}   />
                            </div>
                        </div>
                    </div>
                    <div className="col-fixed " >
                        <Link to={`/grouploancontract/add`}>
                            <Button label={$t('addNewLoan')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            }
            <section className="page-section " >
                <div className="container-fluid">
                    <div className="grid ">
                        <div className="col comp-grid" >
                            <FilterTags filterController={filterController} />
                            <div >
                                <PageBreadcrumbs />
                                <div className="grid ">
                                    <div className="col">
                                        <div className="page-records">
                                            <DataTable 
                                                lazy={true} 
                                                loading={loading} 
                                                selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                                value={records} 
                                                dataKey="loanaccountno" 
                                                sortField={sortBy} 
                                                sortOrder={sortOrder} 
                                                onSort={onSort}
                                                className=" p-datatable-sm" 
                                                stripedRows={true}
                                                showGridlines={false} 
                                                rowHover={true} 
                                                responsiveLayout="stack" 
                                                emptyMessage={<EmptyRecordMessage />} 
                                                >
                                                {/*PageComponentStart*/}
                                                <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                                <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                                <Column  field="loanaccountno" header={$t('loanAccountno')} body={LoanaccountnoTemplate} sortable={true} ></Column>
                                                <Column  field="groupid" header={$t('groupId')} body={GroupidTemplate} sortable={true} ></Column>
                                                <Column  field="memberid" header={$t('memberId')}  sortable={true} ></Column>
                                                <Column  field="branchcode" header={$t('branchCode')} body={BranchcodeTemplate} sortable={true} ></Column>
                                                <Column  field="loanproductid" header={$t('loanProductid')} body={LoanproductidTemplate} sortable={true} ></Column>
                                                <Column  field="loan_type" header={$t('loanType')}  sortable={true} ></Column>
                                                <Column  field="datecontractstarts" header={$t('dateContractStart')} body={DatecontractstartsTemplate} sortable={true} ></Column>
                                                <Column  field="datecontractends" header={$t('dateContractEnd')} body={DatecontractendsTemplate} sortable={true} ></Column>
                                                <Column  field="interestrate" header={$t('interestRate')}  sortable={true} ></Column>
                                                <Column  field="loanamount" header={$t('loanAmount')}  sortable={true} ></Column>
                                                <Column  field="loanpaymentamountdue" header={$t('emi')}  sortable={true} ></Column>
                                                <Column  field="loanterm" header={$t('loanTerm')}  sortable={true} ></Column>
                                                <Column  field="loanpaymentfrequency" header={$t('frequency')}  sortable={true} ></Column>
                                                <Column  field="amort_type" header={$t('amortType')}  sortable={true} ></Column>
                                                <Column  field="loanpaymentduedate" header={$t('paymentDuedate')}  sortable={true} ></Column>
                                                <Column  field="disbursementdate" header={$t('disbursementDate')} body={DisbursementdateTemplate} sortable={true} ></Column>
                                                <Column  field="amountdisbursed" header={$t('amountDisbursed')}  sortable={true} ></Column>
                                                <Column  field="chequeno" header={$t('chequeno')}  sortable={true} ></Column>
                                                <Column  field="ac_code" header={$t('acCode')} body={AcCodeTemplate} sortable={true} ></Column>
                                                <Column  field="processingfee" header={$t('processingFee')}  sortable={true} ></Column>
                                                <Column  field="insurancefee" header={$t('insuranceFee')}  sortable={true} ></Column>
                                                <Column  field="ac_closed" header={$t('acClosed')}  sortable={true} ></Column>
                                                <Column  field="cgst" header={$t('cgst')}  sortable={true} ></Column>
                                                <Column  field="igst" header={$t('igst')}  sortable={true} ></Column>
                                                <Column  field="sgst" header={$t('sgst')}  sortable={true} ></Column>
                                                <Column  field="empcode_sale" header={$t('empcodeSale')}  sortable={true} ></Column>
                                                <Column  field="empcode_collection" header={$t('empcodeCollection')}  sortable={true} ></Column>
                                                <Column  field="appove_roleid" header={$t('appoveRoleid')}  sortable={true} ></Column>
                                                <Column  field="unitid" header={$t('unitid')}  sortable={true} ></Column>
                                                <Column  field="chk_ffirstemi" header={$t('chkFfirstemi')}  sortable={true} ></Column>
                                                <Column  field="first_emi_date" header={$t('firstEmiDate')}  sortable={true} ></Column>
                                                <Column  field="date_closed" header={$t('dateClosed')}   ></Column>
                                                <Column  field="userid" header={$t('userid')}   ></Column>
                                                <Column  field="membermaster_memberid" header={$t('membermasterMemberid')} body={MemberidTemplate}  ></Column>
                                                <Column  field="membermaster_membername" header={$t('membermasterMembername')} body={MembernameTemplate}  ></Column>
                                                <Column  field="membermaster_groupid" header={$t('membermasterGroupid')} body={GroupidTemplate}  ></Column>
                                                <Column  field="membermaster_father_name" header={$t('membermasterFatherName')} body={FatherNameTemplate}  ></Column>
                                                <Column  field="membermaster_husband_name" header={$t('membermasterHusbandName')} body={HusbandNameTemplate}  ></Column>
                                                <Column  field="membermaster_joiningdate" header={$t('membermasterJoiningdate')} body={JoiningdateTemplate}  ></Column>
                                                <Column  field="membermaster_dob" header={$t('membermasterDob')} body={DobTemplate}  ></Column>
                                                <Column  field="membermaster_age" header={$t('membermasterAge')} body={AgeTemplate}  ></Column>
                                                <Column  field="membermaster_addressline1" header={$t('membermasterAddressline1')} body={Addressline1Template}  ></Column>
                                                <Column  field="membermaster_addressline2" header={$t('membermasterAddressline2')} body={Addressline2Template}  ></Column>
                                                <Column  field="membermaster_policestation" header={$t('membermasterPolicestation')} body={PolicestationTemplate}  ></Column>
                                                <Column  field="membermaster_district" header={$t('membermasterDistrict')} body={DistrictTemplate}  ></Column>
                                                <Column  field="membermaster_pincode" header={$t('membermasterPincode')} body={PincodeTemplate}  ></Column>
                                                <Column  field="membermaster_statename" header={$t('membermasterStatename')} body={StatenameTemplate}  ></Column>
                                                <Column  field="membermaster_branchcode" header={$t('membermasterBranchcode')} body={BranchcodeTemplate}  ></Column>
                                                <Column  field="membermaster_id1" header={$t('membermasterId1')} body={Id1Template}  ></Column>
                                                <Column  field="membermaster_id2" header={$t('membermasterId2')} body={Id2Template}  ></Column>
                                                <Column  field="membermaster_idcardnumber" header={$t('membermasterIdcardnumber')} body={IdcardnumberTemplate}  ></Column>
                                                <Column  field="membermaster_idcardnumber_ex" header={$t('membermasterIdcardnumberEx')} body={IdcardnumberExTemplate}  ></Column>
                                                <Column  field="membermaster_idcardpicture" header={$t('membermasterIdcardpicture')} body={IdcardpictureTemplate}  ></Column>
                                                <Column  field="membermaster_religion" header={$t('membermasterReligion')} body={ReligionTemplate}  ></Column>
                                                <Column  field="membermaster_caste" header={$t('membermasterCaste')} body={CasteTemplate}  ></Column>
                                                <Column  field="membermaster_occupation" header={$t('membermasterOccupation')} body={OccupationTemplate}  ></Column>
                                                <Column  field="membermaster_qualification" header={$t('membermasterQualification')} body={QualificationTemplate}  ></Column>
                                                <Column  field="membermaster_mobileno" header={$t('membermasterMobileno')} body={MobilenoTemplate}  ></Column>
                                                <Column  field="membermaster_mobileno_ex" header={$t('membermasterMobilenoEx')} body={MobilenoExTemplate}  ></Column>
                                                <Column  field="membermaster_nomineename" header={$t('membermasterNomineename')} body={NomineenameTemplate}  ></Column>
                                                <Column  field="membermaster_mother_name" header={$t('membermasterMotherName')} body={MotherNameTemplate}  ></Column>
                                                <Column  field="membermaster_marital_status" header={$t('membermasterMaritalStatus')} body={MaritalStatusTemplate}  ></Column>
                                                <Column  field="membermaster_area" header={$t('membermasterArea')} body={AreaTemplate}  ></Column>
                                                <Column  field="membermaster_subarea" header={$t('membermasterSubarea')} body={SubareaTemplate}  ></Column>
                                                <Column  field="membermaster_bankname" header={$t('membermasterBankname')} body={BanknameTemplate}  ></Column>
                                                <Column  field="membermaster_accountno" header={$t('membermasterAccountno')} body={AccountnoTemplate}  ></Column>
                                                <Column  field="membermaster_ifsec" header={$t('membermasterIfsec')} body={IfsecTemplate}  ></Column>
                                                <Column  field="membermaster_resk_evaluated" header={$t('membermasterReskEvaluated')} body={ReskEvaluatedTemplate}  ></Column>
                                                <Column  field="membermaster_photo_upload" header={$t('membermasterPhotoUpload')} body={PhotoUploadTemplate}  ></Column>
                                                <Column  field="membermaster_id_upload" header={$t('membermasterIdUpload')} body={IdUploadTemplate}  ></Column>
                                                <Column  field="membermaster_sign_upload" header={$t('membermasterSignUpload')} body={SignUploadTemplate}  ></Column>
                                                <Column  field="membermaster_house_upload" header={$t('membermasterHouseUpload')} body={HouseUploadTemplate}  ></Column>
                                                <Column  field="membermaster_map_upload" header={$t('membermasterMapUpload')} body={MapUploadTemplate}  ></Column>
                                                <Column  field="membermaster_nominee_relation" header={$t('membermasterNomineeRelation')} body={NomineeRelationTemplate}  ></Column>
                                                <Column  field="membermaster_nominee_age" header={$t('membermasterNomineeAge')} body={NomineeAgeTemplate}  ></Column>
                                                <Column  field="membermaster_pancard" header={$t('membermasterPancard')} body={PancardTemplate}  ></Column>
                                                <Column  field="membermaster_gender" header={$t('membermasterGender')} body={GenderTemplate}  ></Column>
                                                <Column  field="membermaster_pan_verify" header={$t('membermasterPanVerify')} body={PanVerifyTemplate}  ></Column>
                                                <Column  field="membermaster_aadhar_verify" header={$t('membermasterAadharVerify')} body={AadharVerifyTemplate}  ></Column>
                                                <Column  field="membermaster_email" header={$t('membermasterEmail')} body={EmailTemplate}  ></Column>
                                                <Column  field="membermaster_account_verify" header={$t('membermasterAccountVerify')} body={AccountVerifyTemplate}  ></Column>
                                                <Column  field="users_userid" header={$t('usersUserid')} body={UseridTemplate}  ></Column>
                                                <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                                {/*PageComponentEnd*/}
                                            </DataTable>
                                            <div className="flex justify-content-around font-bold p-3">
                                                <div>Total Loanamount : <Chip label={totalLoanamount} /></div>
                                            </div>
                                        </div>
                                        <PageFooter />
                                    </div>
                                    {
                                    (currentRecord && !props.isSubPage) && 
                                    <div className="col-12">
                                        <div className="card p-0">
                                            <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
	);
}
GrouploancontractBranchListPage.defaultProps = {
	primaryKey: 'loanaccountno',
	pageName: 'grouploancontract',
	apiPath: 'grouploancontract/branch_list',
	routeName: 'grouploancontractbranch_list',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default GrouploancontractBranchListPage;
